import { useView } from '../../contexts/ViewContext';
import Programmes from './Programmes';
import ProgrammeDetailPage from './ProgrammeDetailPage';
import ProgrammeEditor from './ProgrammeEditor';

const ProgrammesWrapper: React.FC = () => {
  const { view, setView } = useView();

  if (view.subPage === 'detail' && view.id) {
    return <ProgrammeDetailPage programmeId={String(view.id)} setView={setView} />;
  }

  if (view.subPage === 'edit' || view.subPage === 'new') {
    return <ProgrammeEditor programmeId={view.id ? String(view.id) : undefined} setView={setView} />;
  }

  return <Programmes setView={setView} />;
};

export default ProgrammesWrapper;
